module.exports = __webpack_public_path__ + "img/channel-point.bdaea290.png";